// extracted by mini-css-extract-plugin
var _1 = "CourseLanding_block__4b84b";
var _2 = "CourseLanding_blockContainer__b1f61";
var _3 = "CourseLanding_editorBlockLink__cbfb9";
var _4 = "CourseLanding_footerNav__50a8e";
var _5 = "CourseLanding_root__4e43f";
export { _1 as "block", _2 as "blockContainer", _3 as "editorBlockLink", _4 as "footerNav", _5 as "root" }
